import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';


import Highcharts from 'highcharts';


Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});





export class ChapterFifty extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="Talent is the vital resource that differentiates organizations from each other. Hire the right people with the right skills, and a new company will likely soar. However, in recent years the talent war has gone global, affecting every organization, startup hub and country in the world." />

        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/50.js